import React, { ReactNode } from 'react';

import { Drawer } from '@mui/material';

import { ClearIcon } from 'components/common/Icons/Icons';

import styles from './SideBar.module.scss';

interface SideBarProps {
  title?: string;
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  enableBackdropClick?: boolean;
  showCloseIcon?: boolean;
}

const SideBar = ({
  title = '',
  isOpen,
  onClose,
  children,
  enableBackdropClick = true,
  showCloseIcon = true,
}: SideBarProps) => {
  const handleClose = () => {
    if (enableBackdropClick && onClose) {
      onClose();
    }
  };

  return (
    <Drawer
      anchor={'right'}
      open={isOpen}
      onClose={handleClose}
      ModalProps={{
        BackdropProps: {
          style: {
            backdropFilter: 'blur(7px)',
          },
        },
      }}
    >
      <div className={styles.main}>
        <div className={styles.title}>
          <div>{title}</div>
          {showCloseIcon && <ClearIcon className={styles.closeButton} onClick={onClose} />}
        </div>
        {children}
      </div>
    </Drawer>
  );
};

export default SideBar;
